<template>
    <button id="hamburger"  class="cursor-pointer" ref="openButton" @click="$emit('open-nav')" >
        <span :class="(isHomepage ? 'dark:bg-gray-50 bg-black':'bg-gray-50')"></span>
        <span :class="(isHomepage ? 'dark:bg-gray-50 bg-black':'bg-gray-50')"></span>
    </button>
</template>

<script>
export default {

    computed: {
        isHomepage() {
            return location.pathname == '/';
        }
    }
}
</script>